import React from "react";
import "./ProfilePage.css";

import herosection      from "../../Assets/Images/profile/herosection.png";
import communicationimg from "../../Assets/Images/profile/communicationimg.png";
import understandingimg from "../../Assets/Images/profile/understandingimg.png";
import purposeimg       from "../../Assets/Images/profile/purposeimg.png";
import iconOpen         from "../../Assets/Images/profile/Isolation_Mode.png";
import iconClose        from "../../Assets/Images/profile/Isolation_Mode_Reverse.png";

import teamSportImg   from "../../Assets/Images/profile/teamSportImg.png";
import hiveImg        from "../../Assets/Images/profile/hiveImg.png";
import storyboardImg  from "../../Assets/Images/profile/storyboardImg.png";
import expertiseImg   from "../../Assets/Images/profile/expertiseImg.png";
import ownershipImg   from "../../Assets/Images/profile/ownershipImg.png";
import learnedImg     from "../../Assets/Images/profile/learnedImg.png";
import togetherImg    from "../../Assets/Images/profile/togetherImg.png";

const PROFILE_SECTIONS = [
  {
    heading: "Communication Shapes How Businesses Are Understood.",
    desc: [
      "Every business communicates through its products, services, people, customer experiences, and market presence. The effectiveness of that communication often influences perception, trust, and decision-making.",
      "At Eilan, communication is approached as a business function that supports visibility, understanding, engagement, and growth.",
    ],
    image: communicationimg,
    alt: "Communication shapes how businesses are understood",
    tagline: "Communication is most effective when aligned with business objectives.",
  },
  {
    heading: "Understanding Creates Direction.",
    desc: [
      "Before communication can be developed, businesses need to be understood.",
      "Products, markets, customers, positioning, and business priorities all influence how communication should be structured — understanding ensures clarity, intent, and alignment with broader objectives.",
    ],
    image: understandingimg,
    alt: "Understanding creates direction",
    tagline: "Clarity builds before communication.",
  },
  {
    heading: "Communication Delivers More When It Serves A Purpose.",
    desc: [
      "Communication achieves greater impact when it supports a clearly defined objective.",
      "Whether the requirement is positioning, engagement, education, or growth, strategy helps transform communication from activity into business value.",
    ],
    image: purposeimg,
    alt: "Purpose gives communication direction",
    tagline: "Purpose gives communication direction.",
  },
  {
    heading: "Communication Is A Team Sport.",
    desc: [
      "Modern communication spans strategy, content, multiple formats, platforms, audiences, and technologies — no single discipline can effectively manage the entire communication journey.",
      "Eilan brings together strategy, creative production, animation, digital experiences, and operations within one coordinated execution framework.",
    ],
    image: teamSportImg,
    alt: "Cross-functional communication team",
    tagline: "Different expertise. One communication objective.",
  },
  {
    heading: "Structure Enables Consistency.",
    desc: [
      "Ideas may begin projects. Structure ensures they reach completion with clarity and accountability.",
      "To support this, Eilan developed HIVE — its internally developed operations and workflow platform that connects planning, execution, review, and delivery.",
    ],
    image: hiveImg,
    alt: "HIVE — Eilan's internal operations and workflow platform",
    tagline: "Visibility drives accountability.",
  },
  {
    heading: "Principles Shape Decisions.",
    desc: [
      "The tools may evolve. Technologies may change. Communication formats may continue to expand. The principles guiding our work remain constant:",
    ],
    list: [
      "Clarity Before Creativity.",
      "Strategy Before Execution.",
      "Ownership Over Deliverables.",
      "Consistency Across Every Touchpoint.",
    ],
    image: storyboardImg,
    alt: "Storyboard sketches in progress",
    tagline: "Values guide execution.",
  },
  {
    heading: "Expertise Matters. Collaboration Matters More.",
    desc: [
      "Technology supports execution. Systems improve coordination. Outcomes are ultimately shaped by people.",
      "Eilan brings together professionals across communication strategy, creative development, production, technology, and operations, creating an environment where expertise and collaboration work together.",
    ],
    image: expertiseImg,
    alt: "Cross-disciplinary collaboration",
    tagline: "Collaboration strengthens capability.",
  },
  {
    heading: "Ownership Changes Outcomes.",
    desc: [
      "Successful communication requires more than ideas and execution. It requires accountability for the outcome.",
      "At Eilan, teams remain closely involved throughout the journey — from understanding the requirement and planning the approach to execution, refinement, and delivery.",
    ],
    image: ownershipImg,
    alt: "Team reviewing color and material samples",
    tagline: "Ownership extends beyond delivery.",
  },
  {
    heading: "What We Learned Working Across Industries.",
    desc: [
      "Communication challenges change. The fundamentals do not.",
      "Businesses seek clarity. Teams seek alignment. Customers seek understanding. Regardless of industry, effective communication succeeds when these expectations remain connected.",
    ],
    image: learnedImg,
    alt: "Team collaborating across screens",
    tagline: "Collaboration strengthens capability.",
  },
  {
    heading: "Bringing It All Together.",
    desc: [
      "Communication is most effective when understanding, strategy, expertise, and execution work in alignment.",
      "At Eilan, these elements come together through a structured approach designed to deliver clarity, consistency, and purpose.",
    ],
    image: togetherImg,
    alt: "Mosaic of team and project visuals",
    tagline: "Understanding Is The Starting Point. Communication Is The Outcome.",
  },
];

function ProfileRow({ heading, desc, list, image, alt, tagline, reverse }) {
  return (
    <div className={`comm-row${reverse ? " comm-row--reverse" : ""}`}>
      <div className="comm-text">
        <h3 className="comm-heading">{heading}</h3>
        {desc.map((para, i) => (
          <p className="comm-desc" key={i}>{para}</p>
        ))}
        {list && (
          <ul className="comm-list">
            {list.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
      </div>

      <div className="comm-card-wrap">
        <div className="comm-img-wrap">
          <img src={image} alt={alt} className="comm-img" />
        </div>
        <div className="comm-quote-bar">
          <img src={iconOpen} alt="" className="comm-quote-icon comm-quote-icon--open" />
          <p className="comm-quote-text">
            {tagline}{" "}
            <img src={iconClose} alt="" className="comm-quote-icon-close" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default function ProfilePage() {
  return (
    <div className="profile-page">

      <section className="prof-hero">
        <div className="prof-hero-container">
          <img
            src={herosection}
            alt="The Eilan Way"
            className="prof-hero-graphic"
          />
          <p className="prof-hero-sub">From Understanding To Execution</p>
        </div>
      </section>

      <section className="prof-body">
        <div className="prof-body-container">
          {PROFILE_SECTIONS.map((section, i) => (
            <ProfileRow key={section.heading} {...section} reverse={i % 2 === 1} />
          ))}
        </div>
      </section>

      {/* ══ BOTTOM CTA ══ */}
      <section className="prof-cta">

        <div className="prof-cta-left">
          <h2 className="prof-cta-heading">
            <span className="prof-cta-heading--green">Every Meaningful</span>
            <br />
            Engagement Begins With
            <br />
            A Business Objective.
          </h2>
          <p className="prof-cta-desc">
            Whether the objective is visibility, positioning, engagement,
            education, or growth, every communication journey begins
            with understanding what the business is trying to achieve.
          </p>
        </div>

        <div className="prof-cta-right">
          <p className="prof-cta-card-text">
            Let's Start With
            <br />
            Your Business
            <br />
            Objective.
          </p>
          <a
            href="https://www.eilandigital.com"
            className="prof-cta-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.eilandigital.com
          </a>
        </div>

      </section>

    </div>
  );
}